import { useEffect, useRef, useState } from 'react'
import {
  Card,
  Typography,
  Stack,
  ImageList,
  ImageListItem,
  ListSubheader,
  ImageListItemBar,
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  AvatarGroup,
  Tooltip,
  Avatar,
  Snackbar,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  makeStyles,
  Skeleton,
  Paper,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import {
  ThumbUpAltOutlined,
  ThumbDownOffAltOutlined,
  CancelOutlined,
  Link,
  Notes,
  Description,
  PictureAsPdf,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  Info,
} from '@material-ui/icons'
import { sentenceCase } from 'change-case'
import moment from 'moment'
import Scrollbar from 'src/components/Scrollbar'
import {
  ref as imageref,
  uploadBytesResumable,
  getDownloadURL,
} from '@firebase/storage'
import { storage } from 'src/firebase/firebase'
import { REST_API_END_POINT, UNITS, currentFacilityId, FacilityTypes } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'
import axios from 'axios'
import { LoadingButton } from '@material-ui/lab'
import { UserMoreMenu } from '../user/list'
import Label from 'src/components/Label'
import Modal from '../blog/ProjectModel'
import { AccountNotifications } from '../user/account'
import { empty } from 'src/Helpers/Common'
import { Icon } from '@iconify/react'
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined';
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { DialogAnimate } from 'src/components/animate'
import RequestProgressModal from 'src/components/RequestProgressModal'
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import React from 'react'
import { supabase } from '../../../supabase/supabaseClient';

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
      cursor: 'pointer',
      display: 'flex',
      borderRadius: '6px',
      backgroundColor: '#172e34',
      padding: theme.spacing(1),
      margin: theme.spacing(1, 0),
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative', 
      height: '100px', 
      overflow: 'hidden'
  },
  attachmentIcon: {
      marginRight: theme.spacing(1),
  },
  delete:{
      m:2,
      display:'flex',
      justifyContent:'flex-end' 
    },
  checkbox: {
      position: 'absolute',
      top: theme.spacing(1), 
      right: theme.spacing(1), 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
  },
  dialogContent: {
      padding: theme.spacing(3),
      maxWidth: 768,
      margin: 'auto',
      display: 'flex',
      flexDirection:'column',
      justifyContent: 'center',
      alignItems: 'center',
  },
  gridContainer: {
      height: 'auto',
  },
}));

export default function viewRequest({
  designs=[],
  fromProposal,
  products,
  productsWithLocation,
  user,
  setDesigns,
  details,
  fetchRequestDetails,
  // fetchRequestDetailsNew,
  isRequest,
  requestId,
  signAgreements,
  customTemplate,
  questionnaireTemplate,
  allDataEmpty,
  portfolio,
  project,
  clientDetails,
  teamMembers,
  invoice,
  setInvoice,
  quotation,
  proposalView,
  setRenderCards,
  renderCards,
  rfpServicesEdit,
  requestServices,
  labourInstallService,
  explodedPermissions,
  isEstimate,
  designersList,
  incomingSplitMarkup = 0,
}) {
  const fileInputRef = useRef(null)
  const theme = useTheme()
  const { enqueueSnackbar } = useSnackbar()
  const {
    id,
    doc_number,
    est_doc_number,
    installation_acceptance,
    community_name,
    added_by_name,
    name,
    notes,
    description,
    services,
    submission_deadline,
    participation_ends,
    installation_start_date,
    installation_end_date,
    status,
    reason,
    reasonWithQb,
    estimate_id,
    added_by,
    awarded,
    rfpQbId,
    isFromDesignOrder,
    design_order_id,
    job_category_name,
    avalara_code
  } = details
  console.log('designsdesignsdesignsdesigns', labourInstallService)
  const submissionDate = moment.unix(submission_deadline).format('MM/DD/YYYY')
  const endDate = installation_start_date && installation_end_date 
    ? `${moment.unix(installation_start_date).format('MM/DD/YYYY')} - ${moment.unix(installation_end_date).format('MM/DD/YYYY')}`
    : moment.unix(participation_ends).format('MM/DD/YYYY')
  const xs = useMediaQuery(theme.breakpoints.down('xs'))
  const sm = useMediaQuery(theme.breakpoints.down('sm'))
  const mdd = useMediaQuery(theme.breakpoints.down('md'))
  const xld = useMediaQuery(theme.breakpoints.up('xl'))
  const [progress, setProgress] = useState(false)
  const [modalClose, setModalClose] = useState(false)
  const [openProductModel, setOpenProductModel] = useState(false)
  const [openReasonModal, setOpenReasonModal] = useState(false)
  const [itemId, setItemId] = useState(null)
  const [reasonText, setReasonText] = useState('')
  const [openImageModal,setOpenImageModal] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(null);

  // 🚀 PROGRESS TRACKING: Socket progress modal state
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressRequestData, setProgressRequestData] = useState(null);
  const [socketReady, setSocketReady] = useState(false);
  const [progressHeading, setProgressHeading] = useState('');

  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([]);
  const [invoiceSelectedServices, setInvoiceSelectedServices] = useState([]);
  const [cartService, setCartService] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const classes = useStyles();
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [useOfficeViewer, setUseOfficeViewer] = useState(true);

  const [selectedSecondPDF, setSelectedSecondPDF] = useState(null);
  const [openPDFSecondModal, setOpenPDFSecondModal] = useState(false);
  const [pdfSecondLoading, setPdfSecondLoading] = useState(true);
  const [useOfficeViewerSecond, setUseOfficeViewerSecond] = useState(true);
  const isClient = user?.isClient;
  let userType = isClient ? 3 : user.user_type
  let userId = user.user_id
  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }
  
  let subTotal =invoice?.project_category ==12 ? invoice?.jobcostTotal + 0 : 0 //invoice?.sub_total 
  console.log('#Invoice##########', invoice)
  console.log('productsWithLocation', productsWithLocation)

    // The below useEffect is used for fetching the invoice details only
    useEffect(() => {
      console.log('requestServices--', requestServices);
  
      const rfqServicesData = invoice?.cust_product?.flatMap(product => {
        console.log('product--', product)
        return product.services.map(service => ({
          ...service,
          productIndex: product.product_index,
          product_id: product.product_id,
          qtyData: product.quantity,
          locationQuantity: product.locationQuantity || 1
  
        }));
      });
      console.log("##################rfqInvoiceServiceData", rfqServicesData);
      const newrfqServicesData = rfqServicesData?.filter(item => {
        const newQty = parseFloat((item.prQty * item.qtyData * item.locationQuantity)?.toFixed(2));
        console.log('rfqInvoiceServiceDatanewQty-----------', newQty);
        console.log('rfqInvoiceServiceDataitem.qty-----------', item.qty);
        return newQty !== item.qty;
      }).map(item => {
        const newQty = item.prQty * item.qtyData * item.locationQuantity;
        let quantityDifference = 0;
        if(details?.job_category_name === 'Time & Material'){
          quantityDifference = 0;
        }else{
          quantityDifference = item.qty - newQty;
        }
        return {
          ...item,
          quantity: quantityDifference,
          quantityDifference: quantityDifference,
          total_cost: item.unit_cost * quantityDifference
        };
      });
  
      console.log('newrfqServicesData-------', newrfqServicesData);
  
      setInvoiceSelectedServices(newrfqServicesData || [])
  
      const additionalServices = requestServices?.filter(item => item?.recipe_id === null);
      const additionalServicesData = additionalServices || [];
      const updatedServicesData = additionalServicesData?.map((serviceItem)=>{
        return{
          ...serviceItem,
          productId : serviceItem.labour_cost_service_id,
          addresses: [
            {
              address: serviceItem.address,
              city: serviceItem.city,
              state: serviceItem.state,
              zip: serviceItem.zip,
            }
          ]
        }
      })
      console.log('updatedServicesData----',updatedServicesData);
      setAdditionalSelectedServices(updatedServicesData);
      const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1);
     
      setCartService(rfpServices)
    }, [requestServices, invoice, rfpServicesEdit]);


    const initializeSelectedProducts = (item) => {
      console.log("done 1",item)
      const preSelected = item.location_ids
        ? item.location_ids.split(',').map(id => ({
            id: item.id,
            product_id: parseInt(id.trim(), 10),
            product_name: productsWithLocation?.find(p => p.request_location_id === parseInt(id.trim(), 10))?.product_name || '',
            reason: null,
          }))
        : [];
    
      setSelectedProducts(preSelected);
    };
    

    // const handleCheckboxChange = (product, isChecked,item) => {
    //   console.log('productproduct',product)
    //   setSelectedProducts((prevSelected) => {
    //     if (isChecked) {
    //       // Add product to state if checked
    //       return [...prevSelected, { 
    //         id: item.id, 
    //         // product_id: product.product_id, 
    //         product_id: product.id, 
    //         product_name: product.product_name, 
    //         reason: null, 
    //       }];
    //     } else {
    //       // Remove product from state if unchecked
    //       return prevSelected.filter(
    //         (selected) => selected.product_id !== product.id
    //       );
    //     }
    //   });
    // };
    

    // ✅ Updated `handleCheckboxChange` to handle pre-selected products
const handleCheckboxChange = (product, isChecked, item) => {
  setSelectedProducts((prevSelected) => {
    if (isChecked) {
      // ✅ Add product if checked (avoid duplicates)
      if (!prevSelected.some((p) => p.product_id === product.request_location_id)) {
        return [...prevSelected, { 
          id: item.id, 
          product_id: product.request_location_id, 
          product_name: product.product_name, 
          reason: null, 
        }];
      }
      return prevSelected;
    } else {
      // ❌ Remove product if unchecked
      return prevSelected.filter(
        (selected) => selected.product_id !== product.request_location_id
      );
    }
  });
};


    const handleSubmit = async (attacmentId) => {
      console.log('Selected Products:', selectedProducts);
      let requestId = details.id
      let userId = user.user_id
      let designId =attacmentId

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        requestId,
        userId,
        data: selectedProducts,
        designId,
        approved: true,
        socketId: null // Will be set by the progress modal
      };

      setProgressHeading("Updating Design");
      setProgressRequestData(requestData);
      setShowProgressModal(true);

      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      try {
        const response = await axios.post(`${REST_API_END_POINT}request/update-multi-designs`, requestData)
        if(response.data.status==1){
          await fetchRequestDetails()
          enqueueSnackbar( `Design has been linked Successfully`,{ variant: 'success' },)
          // Only execute finally logic after designs are fetched and displayed
          setModalClose(false)
          setOpenProductModel(false)
          setTimeout(() => {
            setShowProgressModal(false)
          }, 1000);
        }else{
          enqueueSnackbar(response.data.message, { variant: 'error' })
          setModalClose(false)
          setOpenProductModel(false)
          setTimeout(() => {
            setShowProgressModal(false)
          }, 1000);
        }
      } catch (error) {
        console.error('Submit error:', error);
        enqueueSnackbar('Failed to update design', { variant: 'error' });
        setModalClose(false)
        setOpenProductModel(false)
        setTimeout(() => {
          setShowProgressModal(false)
        }, 1000);
      }
  };

  const handleUpdateDesign = async (data) => {
    console.log("numberrrrrrrrrrr",data?.num)
    
    setModalClose(true)
    data.requestId = details.id
    data.userId = user.user_id
    if (data.approved) data.approved_by = user.user_id
    if (data.approved === 0 && reasonText === '') {
      enqueueSnackbar('Please add Reason', { variant: 'error' })
      return
    }
    let productName = ''
    if (data?.hasOwnProperty('product_name')) {
      productName = data?.product_name
      delete data?.product_name
    }

    // 🚀 PROGRESS TRACKING: Show progress modal and make API call
    const requestData = {
      ...data,
      socketId: null // Will be set by the progress modal
    };

    // Set appropriate progress heading based on operation type
    let progressHeading = "Updating Design";
    if (data?.status === 0) {
      progressHeading = "Deleting Design";
    } else if (data.approved === 0 && !data.product_id) {
      progressHeading = "Rejecting Design";
    } else if (data.approved === 1) {
      progressHeading = "Approving Design";
    } else if (data.product_id) {
      progressHeading = "Linking Design";
    }
    
    setProgressHeading(progressHeading);
    setProgressRequestData(requestData);
    setShowProgressModal(true);

    // Wait for socket connection to establish and stabilize
    await new Promise(resolve => setTimeout(resolve, 2000));

    // Additional wait if socket is not ready yet
    if (!socketReady) {
        console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
        await new Promise(resolve => setTimeout(resolve, 1000));
    }

    try {
      const res = await axios.post(`${REST_API_END_POINT}request/update-designs`, requestData);
      
      if (res.data.status === 1) {
        // fetchRequestDetailsNew()
        await fetchRequestDetails()
        enqueueSnackbar(
          data.approved === 1
            ? 'Design has been Approved'
            : data.product_id
            ? `Design has been linked with ${productName}`
            : data?.status == 0
            ? 'Design has been Deleted'
            : 'Design has been Rejected',
          { variant: 'success' },
        )
        // Only execute finally logic after designs are fetched and displayed
        setItemId(null)
        setModalClose(false)
        setOpenProductModel(false)
        setOpenReasonModal(false)
        setReasonText('')
        setTimeout(() => {
          setShowProgressModal(false)
        }, 1000);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' })
        setItemId(null)
        setModalClose(false)
        setOpenProductModel(false)
        setOpenReasonModal(false)
        setReasonText('')
        setTimeout(() => {
          setShowProgressModal(false)
        }, 1000);
      }
    } catch (error) {
      console.error('Design update error:', error);
      enqueueSnackbar('Failed to update design', { variant: 'error' });
      setItemId(null)
      setModalClose(false)
      setOpenProductModel(false)
      setOpenReasonModal(false)
      setReasonText('')
      setTimeout(() => {
        setShowProgressModal(false)
      }, 1000);
    }
  }
  // const handleFileChange = async (event) => {
  //   const file = event.target.files[0]
  //   const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase()
  //   const Filename = new Date().getTime() + file?.name

  //   // const isImage = file?.type?.startsWith('image/')
  //   // const isPdf = file?.type === 'application/pdf'
  //   const isImage =
  //   file?.type?.startsWith('image/') ||
  //   file?.type === 'img' ||
  //   file?.type === 'image'
  // const isPdf = file?.type === 'pdf' || file?.type === 'application/pdf' || file?.type === "other"

  //   if (!isImage && !isPdf) {
  //     enqueueSnackbar(
  //       'Please select a valid file. Only Images and PDF are allowed',
  //       { variant: 'error' },
  //     )
  //     return
  //   }
  //   const StorageRef = imageref(storage, Filename)
  //   const uploadTask = uploadBytesResumable(StorageRef, file)

  //   uploadTask.on(
  //     'state_changed',
  //     (snapshot) => {
  //       const pro = Math.round(
  //         (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
  //       )
  //       setProgress(true)
  //     },
  //     (error) => {
  //       console.error(error.message)
  //       setProgress(false)
  //       enqueueSnackbar('Please upload Image or PDF less than 5 MB', {
  //         variant: 'error',
  //       })
  //     },
  //     () => {
  //       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //         const uploaded = [downloadURL]
  //         const requestId = details.id
  //         const data = {
  //           requestId,
  //           userId: user.user_id,
  //           uploaded,
  //           type: file.type,
  //           size: file.size,
  //           extension: fileExtension,
  //         }
  //         // axios
  //         //   .post(`${REST_API_END_POINT}request/upload-designs`, data)
  //         //   .then((res) => {
  //         //     if (res.data.status === 1) {
  //         //       setDesigns((pv) => [
  //         //         ...pv,
  //         //         ...res.data.data.map((d) => ({
  //         //           ...d,
  //         //           updated_by: user.person_name,
  //         //         })),
  //         //       ])
  //         axios.post(`${REST_API_END_POINT}request/upload-designs`, data)
  //         .then((res) => {
  //           if (res.data.status === 1) {
  //             // setDesigns((prev) => [
  //             //   ...(Array.isArray(prev) ? prev : []), // Ensure prev is an array
  //             //   ...((Array.isArray(res?.data?.data) ? res?.data?.data : [])).map((d) => ({
  //             //     ...d,
  //             //     updated_by: user.person_name,
  //             //   })),
  //             // ]);
  //             if(!fromProposal){
  //             setRenderCards(!renderCards)
  //             }
  //               enqueueSnackbar(res.data.message, { variant: 'success' })
  //             } else {
  //               enqueueSnackbar(res.data.message, { variant: 'error' })
  //             }
  //           })
  //         setProgress(false)
  //         // fetchRequestDetailsNew()
  //         fetchRequestDetails()
  //       })
  //     },
  //   )
  // }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase();
    const isImage =
      file?.type?.startsWith('image/') ||
      file?.type === 'img' ||
      file?.type === 'image';
    const isPdf =
      file?.type === 'pdf' ||
      file?.type === 'application/pdf' ||
      file?.type === 'other';

    if (!isImage && !isPdf) {
      enqueueSnackbar('Please select a valid file. Only Images and PDF are allowed', {
        variant: 'error',
      });
      return;
    }

    const sanitizedName = file.name.replace(/\s+/g, '_');
    const filename = `${Date.now()}_${sanitizedName}`;
    const filePath = `esitmate-sales-order detail/attachments/${filename}`;

    try {
      setProgress(true);

      const { error: uploadError } = await supabase.storage
        .from('signwise-attachments')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const { data: publicUrlData, error: urlError } = supabase.storage
        .from('signwise-attachments')
        .getPublicUrl(filePath);

      if (urlError || !publicUrlData?.publicUrl) {
        throw new Error('Failed to get public URL');
      }

      const downloadURL = publicUrlData.publicUrl;
      const uploaded = [downloadURL];
      const requestId = details.id;

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const dataPayload = {
        requestId,
        userId: user.user_id,
        uploaded,
        type: file.type,
        size: file.size,
        extension: fileExtension,
        socketId: null // Will be set by the progress modal
      };

      setProgressHeading("Uploading Design");
      setProgressRequestData(dataPayload);
      setShowProgressModal(true);

      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, dataPayload);

      if (res.data.status === 1) {
        if (!fromProposal) {
          setRenderCards(!renderCards);
        }
        setProgress(false);
        await fetchRequestDetails();
        enqueueSnackbar(res.data.message, { variant: 'success' });
        // Only execute finally logic after designs are fetched and displayed
        setTimeout(() => {
          setShowProgressModal(false)
        }, 1000);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
        setProgress(false);
        setTimeout(() => {
          setShowProgressModal(false)
        }, 1000);
      }
    } catch (error) {
      console.error('Upload failed:', error.message);
      setProgress(false);
      enqueueSnackbar('Please upload Image or PDF less than 5 MB', {
        variant: 'error',
      });
      setTimeout(() => {
        setShowProgressModal(false)
      }, 1000);
    }
  };

  const approvedCount = designs?.filter((item) => item.approved === 1)?.length
  const linkedCount = designs?.filter((item) => item.approved === 0 )?.length
  const rejectedCount = designs?.filter((item) => item.reason !== null)?.length

  let borderColor

  if (rejectedCount > 0) {
    borderColor = theme.palette.error.main
  } else {
    borderColor = theme.palette.success.main
  }
  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setOpenImageModal(true);
  };

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex));
  };

  const imageDesigns = designs?.filter(
    (item) => item.file_type?.startsWith('image/') || item.file_type === 'img' || item.file_type === 'image'
  );

  // const isReviewAwaiting = details?.isReview == 2 && !empty(details?.allInstallationCompleted);
  const isReviewAwaiting = details?.project_category == 12;

  const manualSubtotal =
    (subTotal || 0) +
    (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
    (cartService?.reduce((s, x) => {
      const sp = x.sellingPrice || x.unit_cost || 0;
      const markup = x.originalMarkup || x.product_markup || 0;
      const final = sp + (sp * markup / 100);
      return s + ((x.qty || 0) * final);
    }, 0) || 0);

  const computedTotal = isReviewAwaiting
    ? (manualSubtotal - (invoice?.extra_discount || 0) + (invoice?.tax_amount || 0)) // subtotal - discount + tax
    : (invoice?.total || 0);

  const total = computedTotal > 0 ? computedTotal : 0;

  const desiredTotal = Number(total.toFixed(2));

  useEffect(() => {
    if (!isReviewAwaiting || !details?.id) return;
    // if (!details?.id && details?.job_category_name !== 'Time & Material') return;

    // prevent redundant updates (and loops due to rounding)
    const currentPersisted = Number((invoice?.total ?? 0).toFixed(2));
    if (currentPersisted === desiredTotal) return;

    let aborted = false;

    (async () => {
      try {
        await axios.post(
          `${REST_API_END_POINT}sales-order/update-review-invoice-total`,
          { requestId: invoice.request_id, orderId: invoice.id, total: desiredTotal, userId }
        );
        if (!aborted) {
          setInvoice(prev => ({
            ...prev,
            total: desiredTotal,
            grandTotal: desiredTotal
          }));
        }
      } catch (e) {
        console.error('Failed to persist review total', e);
      }
    })();

    return () => { aborted = true; };
  }, [desiredTotal, isReviewAwaiting, invoice]);

let customerProductTotal = 0;
  return (
    <Card>
      <Stack sx={{ m: 3 }} spacing={3}>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          <Typography variant="overline" sx={{ color: '#ffffff' }}>
            {name}
            {/* {sentenceCase(name)} */}
          </Typography>
          {reason && (
            <Typography variant="subtitle2"color={'error'}>
              Reason :{reason}
            </Typography>
          )}
          {details?.hold === 1 && details?.hold_reason ? (
            <Typography variant="subtitle2" color={'error'}>
              Hold Reason : {details?.hold_reason}
            </Typography>
          ):''}
        </Stack>
        {added_by == 1 && userType != 3 && (
          <Typography
            variant="subtitle2"
            sx={{
              color: `${
                (proposalView ? !rfpQbId : reasonWithQb || !estimate_id)
                  ? 'red'
                  : 'green'
              }`,
            }}
          >
            {/* {reasonWithQb? reasonWithQb : 'Successfully Synced With QuickBooks'} */}
            {proposalView && awarded == null
              ? ''
              : proposalView
              ? reasonWithQb
                ? reasonWithQb.split('\n').map((line, index) => (
                    <span key={index} style={{ display: 'block' }}>
                      {line}
                    </span>
                  ))
                : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...'
              : estimate_id
              ? 'Successfully Synced With QuickBooks'
              : reasonWithQb
              ? reasonWithQb.split('\n').map((line, index) => (
                  <span key={index} style={{ display: 'block' }}>
                    {line}
                  </span>
                ))
              : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...'}
          </Typography>
        )}
        <Stack
          direction={{ xs: 'column', sm: 'row', md: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          {
            proposalView?(
              <Typography variant="overline" sx={{ color: '#fd6400' }}>
                {avalara_code ?<strong>Avalara Id : {avalara_code}</strong>  :""}
              </Typography>
            )
            :
            ""
          }
          {!proposalView && (
            <Box display='flex' flexDirection='column'>
              {/* <Typography variant="overline" sx={{ color: '#ffffff' }}>
                <strong>Order Id :</strong> {doc_number ? `#${doc_number}` : ''}
              </Typography> */}
                {
                 (installation_acceptance && est_doc_number) && (doc_number !==est_doc_number)?
                 <>
                   <Typography variant="overline" sx={{ color: '#ffffff' }}>
                 <strong>Job Number :</strong> {est_doc_number ? `#${est_doc_number}` : ''}
               </Typography>
                     <Typography variant="overline" sx={{ color: '#ffffff' }}>
                  <strong>Invoice Number :</strong> {doc_number ? `#${doc_number}` : ''}
               </Typography>
               </>
                 :
                 <Typography variant="overline" sx={{ color: '#ffffff' }}>
                 <strong>Order Id :</strong> {doc_number ? `#${doc_number}` : ''}
               </Typography>
               }
              <Typography variant="overline" sx={{ color: '#fd6400' }}>
                {avalara_code ?<strong>Avalara Id : {avalara_code}</strong>  :""}
              </Typography>
              {design_order_id ? 
              <Typography variant="overline" sx={{ color: '#ffffff' }}>
                <strong>Design Order Id :</strong> #{design_order_id}
              </Typography> : ''}
              <Typography variant="body2" sx={{ color: '#ffffff' }}>
                <strong>Created by :</strong> {added_by_name}
              </Typography>
              <Typography variant="body2" sx={{ color: '#ffffff' }}>
                <strong>Created on :</strong> {details?.created_at ? moment.unix(details.created_at).format('MM-DD-YYYY hh:mm:ss A') : 'N/A'}
              </Typography>
              <Typography variant="body2" sx={{ color: '#ffffff' }}>
                <strong>Client Name :</strong> {
                  details?.is_split_order && details?.for_parent_facility == 1 
                    ? FacilityTypes?.find(facility => facility.id === details?.origin_facility_id)?.label || clientDetails?.customer_name || ''
                    : clientDetails?.customer_name || ''
                }
              </Typography>
              <Typography variant="body2" sx={{ color: '#ffffff' }}>
                <strong>Client Address :</strong> {clientDetails?.customer_address}
              </Typography>
              <Typography variant="body2" sx={{ color: '#ffffff' }}>
                <strong>Client Phone :</strong> {clientDetails?.customer_phone}
              </Typography>
              <Typography variant="body2" sx={{ color: '#ffffff' }}>
                <strong>Project Name :</strong> {community_name}
              </Typography>
              {job_category_name?
              <Typography variant="body2" sx={{ color: '#ffffff' }}>
                <strong>Job Type :</strong> {job_category_name} 
              </Typography>
              :""}
               {design_order_id && (<>
                <Typography alignItems={'center'} variant="subtitle1" sx={{ mt: 2 }}>
                  Designers List
                </Typography>
                <Scrollbar sx={{ width: '100%', height: 100, mt: 1.5 }}>
                  <Stack>
                    {designersList?.map((row, index) => (
                      <Stack
                        key={index}
                        direction='row'
                        mb={1}
                        spacing={1.5} 
                        alignItems='center'
                      >
                        <Avatar src={row?.profile_pic} alt={row?.name} />
                        <Typography variant="subtitle2">
                          {row?.name}
                        </Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Scrollbar>
              </>)}
            </Box>
          )}
          <Box sx={{ minWidth: 200, borderColor: 'GrayText' }}>
            {/* empty(quotation)&& details?.job_category_name!='Service only' && details?.job_category_name!='Time & Material' && */}
            {invoice && invoice?.total != 0 && userType != 3 && (
              <>
                <Typography alignItems={'center'} variant="subtitle1">
                  Staff Members
                </Typography>
                <Scrollbar sx={{ width: '100%', height: 100 }}>
                  <Stack>
                    {teamMembers?.map((row) => (
                      <Stack
                        direction={{ xs: 'column', sm: 'row', md: 'row' }}
                        mb={1}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Avatar
                          src={row?.profile_pic}
                          alt={row?.first_name + ' ' + row?.last_name}
                        />
                        <Typography variant="caption">
                          {row?.first_name + ' ' + row?.last_name}
                        </Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Scrollbar>
              </>
            )}
          </Box>
        </Stack>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          <Box sx={{ width: '60%' }}>
            <Stack sx={{ flexDirection: 'row' }}>
              <Tooltip title="Description">
                <Description />
              </Tooltip>
              <Typography
                variant="body2"
                sx={{ color: '#ffffff', flexWrap: 'wrap', ml: 2 }}
              >
                {description}
              </Typography>
            </Stack>
          </Box>
          {/* {invoice?<Typography variant="caption" sx={{ color: '#ffffff' }}>
            {invoice[0].name}
          </Typography>:""} */}
          <Box sx={{ width: '35%' }}>
            {!user.isVendor && empty(quotation) && (
              <Stack>
                <Typography variant="overline" sx={{ color: '#ffffff' }}>
                  Requested Start Date: {submissionDate}
                </Typography>
                <Typography variant="overline" sx={{ color: '#ffffff' }}>
                  Requested Installation Date:{endDate}
                </Typography>
              </Stack>
            )}
          </Box>
        </Stack>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          // sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          {notes ? (
            <>
              <Tooltip title="Notes">
                <Notes sx={{color: 'error.main'}}/>
              </Tooltip>
              <Typography variant="caption" sx={{ flexWrap: 'wrap', color: 'error.main' }}>
                {notes}
              </Typography>
            </>
          ) : (
            ''
          )}
        </Stack>
        {/* <Grid container spacing={2}> */}
          {/* <Scrollbar> */}
          {(project || fromProposal) ? null :
            <Stack>
              <Box
              sx={{
                border: '1px solid',
                borderColor: theme.palette.divider,
                padding: 2,
                overflow: 'auto'
              }}
            >
                {/* {((details?.job_category_name == 'Time & Material') && (details?.allInstallationCompleted == 1)) ?  */}
                {(details?.job_category_name == 'Time & Material') ? 
                  <>
                    {(invoice?.cust_product?.filter(item=>item.material != 1)?.length > 0) ? <>
                      <Typography variant='h6'>{'Products'}</Typography>
                      <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>{'PRODUCT & NOTE' }</TableCell>
                              {invoice?.cust_product?.filter(item=>item.material != 1)?.some(item => item.product_notes) && <TableCell>SKU</TableCell>}
                              <TableCell>UNIT PRICE EACH</TableCell>
                              <TableCell align="center">UNIT</TableCell>
                              <TableCell>QTY</TableCell>
                              {/* <TableCell>MARKETING ADJUSTMENT (%)</TableCell> */}
                              <TableCell>SUB TOTAL</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice?.cust_product?.filter(item=>item.material != 1)?.map((val) => {
                              const { vid, product_name, product_notes,vpt_number, product_price, product_retail_price, adjustment, 
                                quantity, locationQuantity, product_total, discount, unit, unit_qty, material,rfp,markAdjType,
                                services = [],
                              } = val
                              console.log('val--------------',val);
                              const labourService = services?.find(service => service.labour_cost_service_id === 10);
                              const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;

                              let unitName = UNITS?.filter((item) => item?.id == unit)
                              unitName = unitName[0]?.name
                              let shortUnitName = ''
                              if (unitName == 'Square feet') {
                                shortUnitName = 'Sq ft'
                              } else if (unitName == 'Lineal feet') {
                                shortUnitName = 'Lin ft'
                              } else if (unitName == 'Square Inches') {
                                shortUnitName = 'Sq Inches'
                              } else {
                                shortUnitName = 'Unit'
                              }
                              //  subTotal += product_total    
                              let SPMA = 0
                              if(markAdjType==2 || markAdjType==3){
                                SPMA = (product_retail_price || 0) +  (adjustment ? Number(adjustment) : 0)
                
                              }else{

                                SPMA = (product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                              }
                              SPMA = parseFloat(SPMA)?.toFixed(2)           
                              // let rowTotal = 0
                              // if (markAdjType == 1){
                              //   rowTotal = product_total ? ( product_total - minusAmountLabourInstall)?.toFixed(2) : 0.00
                              // }else{
                              //   rowTotal = ((SPMA * (locationQuantity * quantity))-minusAmountLabourInstall).toFixed(2)
                              // }
                              // customerProductTotal = rowTotal ? rowTotal?.toFixed(2) : 0.00
                              let rowTotal = 0;

                              if (markAdjType == 1) {
                                  rowTotal = product_total || 0.00;
                              } else {
                                  rowTotal = (SPMA * (locationQuantity * quantity) - minusAmountLabourInstall);
                              }

                              // Ensure rowTotal is a number before calling toFixed
                              if (typeof rowTotal === 'number') {
                                  customerProductTotal = rowTotal.toFixed(2);
                              } else {
                                  customerProductTotal = "0.00"; // Handle the case where rowTotal isn't a valid number
                              }
                              console.log('customerProductTotal', customerProductTotal , invoice?.jobcostTotal)
                              return (

                                <TableRow key={vid} sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                    {/* <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography> */}
                                    {product_notes ? 
                                      <Typography variant='subtitle2' sx={{fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_notes}</Typography> 
                                    : 
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                                    }
                                   {(material === 1 && rfp === 0 && details?.job_category_name != 'Time & Material') && (
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      (Addl. Material{val?.stock_type === 1 
                                        ? ' - Finished' 
                                        : val?.stock_type === 2 
                                          ? ` - Partial (${UNITS?.find(u => u.id === val?.convertion_unit)?.short_name || 'Unit'})` 
                                          : ''})
                                    </Typography>
                                  )}
                                  {(material === 1 && rfp === 1 && details?.job_category_name != 'Time & Material') && (
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      (Material)
                                    </Typography>
                                  )}

                                  </TableCell>
                                  {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''}
                                  <TableCell>{SPMA ? SPMA : 0.00}  {minusAmountLabourInstall && minusAmountLabourInstall > 0? "(Included Labor Install)" :""}</TableCell>
                                  <TableCell align="center">{material === 1 ? '1' : quantity} ({shortUnitName})</TableCell>
                                  <TableCell>{locationQuantity}</TableCell>
                                  {/* <TableCell>{discount ? discount?.toFixed(2) : 0.00}</TableCell> */}
                                  {/* <TableCell>{(material === 1 || rfp === 1) ? 0.00 : adjustment ? Number(adjustment)?.toFixed(2) : 0.00}</TableCell> */}
                                  
                                  {markAdjType==1?
                                <TableCell>{product_total ?(product_total)?.toFixed(2) : 0.00}</TableCell>
                                // <TableCell>{product_total ?( product_total)?.toFixed(2) : 0.00}</TableCell>
                              :
                              <TableCell>{(SPMA * (locationQuantity * quantity))?.toFixed(2)}</TableCell>

                              }
                                  {/* <TableCell>{product_total ? product_total?.toFixed(2) : 0.00}</TableCell> */}
                                </TableRow>
                              )
                            }
                            )}

                          </TableBody>
                        </Table>
                      </TableContainer>
                    </> : null}
                    <Typography variant='h6' sx={{ mt: 2 }}>{(labourInstallService?.length > 0 ) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Services(Labor Install)" : 'Services(Labor Install)') : ""}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      {(labourInstallService?.length > 0 ) &&
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>NAME</TableCell>
                            <TableCell>COST (HOURLY)</TableCell>
                            <TableCell>HOURS</TableCell>
                            <TableCell>TOTAL COST</TableCell>
                          </TableRow>
                        </TableHead>}
                      <TableBody>
                      {labourInstallService?.map((ser) => {
                          console.log('invoiceSelectedServices--@@ 1', ser);
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell colSpan={2}>{ser?.name}-({ser.productName})</TableCell>
                              <TableCell>{ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                              <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                              <TableCell>{ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                            </TableRow>
                          )
                        })}
                        </TableBody>
                        </Table>
                    </TableContainer>
                    {(!empty(invoice?.jobcost_product)) ? 
                    <>
                    <Typography variant='h6' sx={{ mt: 2 }}>Materials</Typography> 
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>NAME</TableCell>
                            <TableCell>UNIT COST</TableCell>
                            <TableCell>QUANTITY</TableCell>
                            <TableCell>TOTAL COST</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {invoice?.jobcost_product?.map((val,index) => {
                            const { id, product_name, unit_price, quantity,actual_total,actual_quantity, total, unit,partial_unit, unit_qty } = val
                            let unitToUse = partial_unit ? partial_unit : unit
                            let unitName = UNITS?.filter((item) => item?.id == unitToUse)
                            let shortUnitName = unitName[0]?.short_name || 'Unit'
                            unitName = unitName[0]?.name
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>{product_name}</TableCell>
                                <TableCell> {unit_price}</TableCell>
                                <TableCell>{quantity}({shortUnitName})</TableCell>
                                <TableCell> {total}</TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </>
                    : ''}
                    {/* {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? <Typography variant='h6' sx={{ mt: 2 }}>Additional Services</Typography> : ''} */}
                    <TableContainer>
                        <Table>
                        {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? 
                        <>
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan={2}>ADDITIONAL SERVICES</TableCell>
                              <TableCell>HOURLY COST</TableCell>
                              <TableCell>HOURS</TableCell>
                              <TableCell>TOTAL COST</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.map((ser,index) => {
                              return (
                                <TableRow sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  <TableCell colSpan={2}>{ser?.name}
                                  {ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ''}</TableCell>
                                  <TableCell>{ser ? parseFloat(ser?.service_original_cost)?.toFixed(2) : 0}</TableCell>
                                  {/* <TableCell>{ser ? parseFloat(ser?.jobcost_quantity)?.toFixed(2) : 0}</TableCell> */}
                                  <TableCell>{ser ? parseFloat(ser?.quantity)?.toFixed(2) : 0}</TableCell>
                                  <TableCell>{ser ? ser?.total_service_cost : 0}</TableCell>
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </> : ''}
                        {(invoice?.jobcostTotal && invoice?.jobcostTotal > 0) ? (
                          <RowResultStyle>
                            <TableCell colSpan={3} />
                            <TableCell align="right">
                              <Typography variant="overline">Material Total</Typography>
                            </TableCell>
                            <TableCell align="left" width={10}>
                              <Typography variant="overline">${invoice ? invoice?.jobcostTotal?.toFixed(2) : 0.00}</Typography>
                            </TableCell>
                          </RowResultStyle>
                        ) : ''}
                        {/* {(invoice?.project_category == 12 && details?.allInstallationCompleted == 1) ? '' : */}
                        {(invoice?.project_category == 12 ) ? '' :
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Product Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">
                              ${invoice?.cust_product?.reduce((sum, val) => {
                                const {
                                  product_retail_price = 0, adjustment = 0, markAdjType,
                                  product_total = 0, locationQuantity = 1, quantity = 1,
                                  services = []
                                } = val;

                                const labourService = services?.find(s => s.labour_cost_service_id === 10);
                                const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;

                                let SPMA = (markAdjType === 2 || markAdjType === 3)
                                  ? product_retail_price + Number(adjustment)
                                  : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                                const effectiveTotal = markAdjType === 1
                                  ? product_total - labourTotal
                                  : (SPMA * (locationQuantity * quantity)) - labourTotal;

                                return sum + effectiveTotal;
                              }, 0)?.toFixed(2)}
                            </Typography> */}
                            <Typography variant="overline">
                              ${invoice?.cust_product?.reduce((sum, val) => {
                                const {
                                  product_retail_price = 0, adjustment = 0, markAdjType,
                                  product_total = 0,actual_retail_price,install_cost, locationQuantity = 1, quantity = 1,
                                  services = []
                                } = val;

                                const labourService = services?.find(s => s.labour_cost_service_id === 10);
                                const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;
                                console.log('labourTotal', labourTotal)
                                const basePrice = actual_retail_price !== 0 && actual_retail_price != null
                                ? actual_retail_price
                                : product_retail_price;
                                // let SPMA = (markAdjType === 2 || markAdjType === 3)
                                //   ? product_retail_price + Number(adjustment)
                                //   : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                                // const effectiveTotal = markAdjType === 1
                                //   ? product_total
                                //   : (SPMA * (locationQuantity * quantity));
                                let SPMA = (markAdjType === 2 || markAdjType === 3)
                                  ? basePrice + Number(adjustment)
                                  : basePrice + ((basePrice * Number(adjustment)) / 100);

                                const effectiveTotal = markAdjType === 1
                                // ? product_total
                                ? (SPMA * (locationQuantity * quantity))
                                : (SPMA * (locationQuantity * quantity));
                                console.log('effectiveTotal', effectiveTotal)
                                
                                return sum + effectiveTotal;
                              }, 0)?.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>
                        }
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Install Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">
                                ${invoice?.cust_product?.reduce((sum, val) => {
                                  const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                                  return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                                }, 0)?.toFixed(2)}
                            </Typography> */}
                            <Typography variant="overline">
                              ${(
                                //   (invoice?.cust_product?.reduce((sum, val) => {
                                //     const labourService = val?.services?.find(
                                //       s => s.labour_cost_service_id === 10
                                //     );
                                //     return (
                                //       sum +
                                //       (labourService?.service_original_cost || 0) *
                                //         (labourService?.prQty || 0) *
                                //         (val?.locationQuantity || 1)
                                //     );
                                //   }, 0) || 0) +
                                //   (additionalSelectedServices?.reduce(
                                //     (s, x) =>
                                //       x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                //     0
                                //   ) || 0)
                                // ).toFixed(2)
                                (invoice?.cust_product?.reduce((sum, val) => {
                                    const installCost = parseFloat(val?.install_cost || 0);
                                    const locationQty = parseFloat(val?.locationQuantity || 1);
                                    const quantity = parseFloat(val?.quantity || 1);

                                    if (installCost) {
                                      return sum + installCost * locationQty * quantity;
                                    }
                                    return sum;
                                  }, 0) || 0) +
                                  (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                    0
                                  ) || 0)
                                ).toFixed(2)
                                }
                            </Typography>
                          </TableCell>
                        </RowResultStyle>

                         <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                            {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                            <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                            <Typography variant="overline">
                              ${(
                                (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10 
                                        ? s
                                        : s + (x.total_cost || 0),
                                    0
                                ) || 0) +
                                (cartService?.reduce((s, x) => {
                                  const sp = x.sellingPrice || x.unit_cost || 0;
                                  const markup = x.originalMarkup || x.product_markup || 0;
                                  const final = sp + (sp * markup / 100);
                                  return s + ((x.qty || 0) * final);
                                }, 0) || 0)
                              )?.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>

                        {(details?.job_category_name != 'Service only' || subTotal > 0) &&
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Subtotal</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">
                              ${(
                                (subTotal || 0) +
                                // (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (cartService?.reduce((s, x) => {
                                  const sp = x.sellingPrice || x.unit_cost || 0;
                                  const markup = x.originalMarkup || x.product_markup || 0;
                                  const final = sp + (sp * markup / 100);
                                  return s + ((x.qty || 0) * final);
                                }, 0) || 0)
                              )?.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>}

                        {invoice?.extra_discount > 0 && (
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Discount</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {/* {invoice?.tax_amount > 0 && ( */}
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Tax</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        {/* )} */}

                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="subtitle1"  sx={{ color: invoice?.total < 0 ? 'red' : 'inherit' }}>Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="subtitle1"  sx={{ color: invoice?.total < 0 ? 'red' : 'inherit' }}>${invoice?.total ? invoice?.total?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>

                        {invoice?.project_category == 13 ? '' : 
                          <>
                            {(userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
                            (details?.billing_type ? (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right" sx={{display:"flex", alignItems: "center",gap: 1}}>
                                <Typography fontSize={"small"} variant="caption"  sx={{ color:  'inherit' }}> (only viewable for admin)</Typography>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>Billing Type</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            ) : '') :""}
                          {(invoice?.total && details?.billing_type) ?
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>Minimum Payable Amount</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>${(invoice?.total && details?.billing_type)? parseFloat((invoice?.total *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            :""
                            }
                            {details?.totalPaidAmount > 0 && (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>Amount Paid</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>${details?.totalPaidAmount ? parseFloat(details?.totalPaidAmount)?.toFixed(2) : 0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            )}
                            {details?.totalPaidAmount > 0 && (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color: details?.dueAmount <= 0 ? 'inherit' : 'red' }}>Balance Due</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color: details?.dueAmount <= 0 ? 'inherit' : 'red' }}>${details?.dueAmount ? parseFloat(details?.dueAmount <= 0 ? 0.00 : details?.dueAmount)?.toFixed(2) : 0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            )}
                          </>
                        }
                      </Table>
                    </TableContainer>
                    {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
                      <>
                        <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                        <Stack spacing={2}>
                          {invoice?.note_data?.map((val, index) => {
                            const { id, authorized_by, note, timestamp } = val;
                            return (
                              <Paper
                                key={id}
                                elevation={3}
                                sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                              >
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={8}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                      {note}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                    {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                                    <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                      Added By: {authorized_by}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                      {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Paper>
                            );
                          })}
                        </Stack>
                      </>
                    ) : ''}
                  </> :
                  <>
                  {(invoice?.cust_product?.length > 0) ? <>
                  <Typography variant='h6'>{details?.job_category_name != 'Time & Material' ? 'Products' : 'Products'}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>PRODUCT & NOTE</TableCell>
                          {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>SKU</TableCell> : ''}
                          <TableCell align="center">UNIT</TableCell>
                          <TableCell align="center">QTY</TableCell>
                          {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell align="center">WHOLESALE PRICE</TableCell> : ''}
                          {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell align="center">SPLIT MARKUP</TableCell> : ''}
                          <TableCell align="center">UNIT PRICE EACH</TableCell>
                          <TableCell>TOTAL</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {invoice?.cust_product?.map((val) => {
                          const { vid,split_percentage,wholesale_price, product_name,facility_id,expected_cost,incoming_split_percentage, product_notes,vpt_number, product_price, product_retail_price, adjustment, 
                            quantity, locationQuantity,actual_retail_price,install_cost, product_total, discount, unit, unit_qty, material,rfp,markAdjType,
                            services = [],
                          } = val
                          console.log('val--------------',val);
                          
                          // Get labor install
                          const labourService = services?.find(service => service.labour_cost_service_id === 10);
                          const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                          const labourQty = (labourService?.prQty || 0) * locationQuantity;
                          console.log('labourQtylabourQty', labourQty)
                          const labourRate = labourService?.service_original_cost || 0;
                          const labourTotal = labourQty * labourRate;
                          const labourInitial = (labourService?.prQty || 0) * labourRate;
                          
                          // Unit name logic
                          let unitData = UNITS?.filter((item) => item?.id == unit)
                          let shortUnitName = unitData[0]?.short_name || 'Unit'
                          let unitName = unitData[0]?.name
                          
                          //  subTotal += product_total    
                          let SPMA = 0
                          if(markAdjType==2 || markAdjType==3){
                            SPMA = (product_retail_price || 0) +  (adjustment ? Number(adjustment) : 0)
                          }else{
                            SPMA = (product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                          }
                          SPMA = parseFloat(SPMA)?.toFixed(2)                 
                          return (
                            <React.Fragment key={vid}>
                              {/* Product Row */}
                              <TableRow
                              //  sx={{
                              //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              // }}
                              >
                                <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                  {product_notes ? 
                                    // <Typography variant='body2' sx={{textDecoration: 'underline',color: 'error.main'}}>Note : </Typography> 
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold' , mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_notes}</Typography> 
                                    : 
                                    <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>

                                  }
                                  {(material === 1 && rfp === 0 && details?.job_category_name != 'Time & Material') && (
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      (Addl. Material{val?.stock_type === 1 
                                        ? ' - Finished' 
                                        : val?.stock_type === 2 
                                          ? ` - Partial (${UNITS?.find(u => u.id === val?.convertion_unit)?.short_name || 'Unit'})` 
                                          : ''})
                                    </Typography>
                                  )}
                                  {(material === 1 && rfp === 1 && details?.job_category_name != 'Time & Material') && (
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      (Material)
                                    </Typography>
                                  )}
                                </TableCell>
                                {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''}
                                {/* <TableCell align="center">{material === 1 ? '1' : quantity} ({shortUnitName})</TableCell> */}
                                <TableCell align="center">{material === 1 ? `1 (${shortUnitName})` : '-'}</TableCell>
                                <TableCell align="center">{locationQuantity}</TableCell>
                                {/* Outgoing Percentage column - only show when isSplitOrder is true */}
                                {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                                <TableCell align="center">
                                  {details?.is_split_order && facility_id != currentFacilityId && wholesale_price ? `$${wholesale_price || 0}` : '-'}
                                </TableCell>
                                :''
                                }
                                {/* Incoming Percentage column - only show when isSplitOrder is true */}
                                {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                                <TableCell align="center">
                                  {details?.is_split_order && facility_id != currentFacilityId && incoming_split_percentage ? `${incoming_split_percentage || 0}%` : '-'}
                                </TableCell>
                                :''
                                }
                                {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                                {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                                <Tooltip title={
                                  details?.is_split_order && facility_id != currentFacilityId && userType !=3
                                    ? `Wholesale price  + (Wholesale price  * split markup (${incoming_split_percentage || 0}) / 100)` 
                                    : ""
                                }>
                                  <TableCell align="center">${(Number(actual_retail_price) || (Number(SPMA) || 0)).toFixed(2)}</TableCell>
                                </Tooltip>
                                {/* <TableCell>{locationQuantity}</TableCell> */}
                                {markAdjType==1?
                                  // <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                                  <TableCell>${
                                    install_cost ?
                                    ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                    material === 1 ?
                                    ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                    ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                    }</TableCell>
                                :
                                  // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                                  <TableCell>${
                                    install_cost ?
                                    ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                    material === 1 ?
                                    ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                    ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                    }</TableCell>
                                }
                              </TableRow>
                              {/* Labor Install Row (if exists) */}
                              {/* {labourService && (
                                <TableRow>
                                  <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                                  <TableCell align="center">N/A</TableCell>
                                  <TableCell>${labourRate?.toFixed(2)}</TableCell>
                                  <TableCell>{labourQty?.toFixed(2)}</TableCell>
                                  <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                                </TableRow>
                              )} */}
                              {install_cost ? (
                                <TableRow>
                                  <TableCell sx={{ pl: 4 }}>Install Price</TableCell>
                                  {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>-</TableCell> : ''}
                                  <TableCell align="center">-</TableCell>
                                  {/* Outgoing Percentage column for Install Price - only show when isSplitOrder is true */}
                                  {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                                    <TableCell align="center">
                                      {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                                    </TableCell>
                                    : ''
                                  }
                                  {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                                  {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                                    <TableCell align="center">
                                      {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                                    </TableCell>
                                    : ''
                                  }
                                  <TableCell align="center">-</TableCell>
                                  <TableCell align="center">${install_cost || 0}</TableCell>
                                  <TableCell>
                                    ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)}
                                  </TableCell>

                                </TableRow>
                              ):''}
                              <TableRow>
                                <TableCell colSpan={
                                  (invoice?.cust_product?.some(item => item.product_notes) ? 6 : 5) + 
                                 (details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3 ? 2 : 0)
                                }>
                                  <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          )
                        }
                        )}

                      </TableBody>
                    </Table>
                  </TableContainer>
                  </> : null}

{/*below for labour Install */}
                  {/* <Typography variant='h6' sx={{ mt: 2 }}>{(labourInstallService?.length > 0 ) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Services(Labor Install)" : 'Services(Labor Install)') : ""}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      {(labourInstallService?.length > 0 ) &&
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>NAME</TableCell>
                            <TableCell>COST (HOURLY)</TableCell>
                            <TableCell>HOURS</TableCell>
                            <TableCell>TOTAL COST</TableCell>
                          </TableRow>
                        </TableHead>}
                      <TableBody>
                      
                      {labourInstallService?.map((ser) => {
                          console.log('invoiceSelectedServices--@@ 1', ser);
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell colSpan={2}>{ser?.name}-({ser.productName})</TableCell>
                              <TableCell>{ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                              <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                              <TableCell>{ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                            </TableRow>
                          )
                        })}
                        </TableBody>
                        </Table>
                        </TableContainer> */}

{/*above  for labour Install */}


                  {/* <Typography variant='h6' sx={{ mt: 2 }}>{(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Additional Services" : 'Services') : ""}</Typography> */}
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      {(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) &&
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>{(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "ADDITIONAL SERVICES" : 'SERVICES') : ""}</TableCell>
                            <TableCell>COST (HOURLY)</TableCell>
                            <TableCell>HOURS</TableCell>
                            <TableCell width={'15%'}>TOTAL COST</TableCell>
                          </TableRow>
                        </TableHead>}
                      <TableBody>
                        {invoice?.cust_product?.map((val) => {
                          const { vid, product_name, product_price, product_retail_price,
                            quantity, product_total, discount, unit, unit_qty,markAdjType,adjustment,locationQuantity
                          } = val
                          let unitName = UNITS?.filter((item) => item?.id == unit)
                          unitName = unitName[0]?.name
                          let shortUnitName = ''
                          if (unitName == 'Square feet') {
                            shortUnitName = 'Sq ft'
                          } else if (unitName == 'Lineal feet') {
                            shortUnitName = 'Lin ft'
                          } else if (unitName == 'Square Inches') {
                            shortUnitName = 'Sq Inches'
                          } else if (unitName == 'Unit') {
                            shortUnitName = 'Unit'
                          }

                          let SPMA = 0
                        if(markAdjType==2 || markAdjType==3) {
                          SPMA = (product_retail_price || 0) + (adjustment ? Number(adjustment) : 0)
                        }else{
                          SPMA = (product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)

                        }
                        SPMA = parseFloat(SPMA)?.toFixed(2)  

                        let theSubTotalAmount =markAdjType==1?product_total: (SPMA * (locationQuantity * quantity))
                        console.log('theSubTotalAmount', theSubTotalAmount)

                          subTotal += theSubTotalAmount
                          return (
                            null
                          )
                        })}

                        {invoiceSelectedServices?.map((ser) => {
                          console.log('invoiceSelectedServices--@@', ser);
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell colSpan={2}>{ser?.name}
                              {ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ''}</TableCell>
                              <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                              <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                              <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                            </TableRow>
                          )
                        })}

                        {additionalSelectedServices
                          ?.filter(servItem=>{
                            // if (details?.job_category_name != 'Time & Material' && servItem.labour_cost_service_id == 10) {
                            //   return false;
                            // }
                            return true;
                          })?.map((ser) => {
                            console.log('additionalSelectedServices--', ser);
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>{ser?.name}
                                {ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ''}</TableCell>
                                <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                                <TableCell>{ser ? parseFloat(ser?.quantity)?.toFixed(2) : 0}</TableCell>
                                <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                              </TableRow>
                            )
                          }
                        )}

                        {cartService?.map((ser) => {
                          
                          console.log('cartServicecartService', ser)
                          ser.sellingPrice = details?.project_category == 13 ? ser.unit_cost : ser.sellingPrice || ser.unit_cost
                          ser.originalMarkup = details?.project_category == 13 ? 0 :ser.originalMarkup || ser.product_markup
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell colSpan={2}>{ser?.name}
                              {ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ''}</TableCell>
                              <TableCell> ${((ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>
                              <TableCell>{ser ? ser?.qty?.toFixed(2) : 0}</TableCell>
                              <TableCell> ${(ser.qty * (ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>
                            </TableRow>
                          )
                        }
                        )}
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Product Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">
                              ${invoice?.cust_product?.reduce((sum, val) => {
                                const {
                                  product_retail_price = 0,material = 0, adjustment = 0, markAdjType,
                                  product_total = 0,actual_retail_price,install_cost, locationQuantity = 1, quantity = 1,
                                  services = []
                                } = val;

                                const labourService = services?.find(s => s.labour_cost_service_id === 10);
                                const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;
                                console.log('labourTotal', labourTotal)
                                const basePrice = actual_retail_price !== 0 && actual_retail_price != null
                              ? actual_retail_price
                              : product_retail_price;
                                // let SPMA = (markAdjType === 2 || markAdjType === 3)
                                //   ? product_retail_price + Number(adjustment)
                                //   : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                                // const effectiveTotal = markAdjType === 1
                                //   ? product_total
                                //   : (SPMA * (locationQuantity * quantity));
                                let SPMA = (markAdjType === 2 || markAdjType === 3)
                                  ? basePrice + Number(adjustment)
                                  : basePrice + ((basePrice * Number(adjustment)) / 100);
                                const effectiveTotal = markAdjType === 1 && material === 0 
                                  // ? product_total
                                  ? (SPMA * (locationQuantity * quantity)) :
                                  material === 1 ? (SPMA * locationQuantity)
                                  : (SPMA * (locationQuantity * quantity));
                                return sum + effectiveTotal;
                              }, 0)?.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>

                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Install Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">
                                ${invoice?.cust_product?.reduce((sum, val) => {
                                  const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                                  return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                                }, 0)?.toFixed(2)}
                            </Typography> */}
                            <Typography variant="overline">
                              ${(
                                  // (invoice?.cust_product?.reduce((sum, val) => {
                                  //   const labourService = val?.services?.find(
                                  //     s => s.labour_cost_service_id === 10
                                  //   );
                                  //   return (
                                  //     sum +
                                  //     (labourService?.service_original_cost || 0) *
                                  //       (labourService?.prQty || 0) *
                                  //       (val?.locationQuantity || 1)
                                  //   );
                                  // }, 0) || 0) +
                                  (invoice?.cust_product?.reduce((sum, val) => {
                                    const installCost = parseFloat(val?.install_cost || 0);
                                    const locationQty = parseFloat(val?.locationQuantity || 1);
                                    const quantity = parseFloat(val?.quantity || 1);

                                    if (installCost) {
                                      return sum + installCost * locationQty * quantity;
                                    }
                                    return sum;
                                  }, 0) || 0) +
                                  (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                    0
                                  ) || 0)
                                ).toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>

                         <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                            {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                            <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                            <Typography variant="overline">
                              ${(
                                (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10       // ⬅ skip labour install rows
                                        ? s
                                        : s + (x.total_cost || 0),
                                    0
                                ) || 0) +
                                (cartService?.reduce((s, x) => {
                                  const sp = x.sellingPrice || x.unit_cost || 0;
                                  const markup = x.originalMarkup || x.product_markup || 0;
                                  const final = sp + (sp * markup / 100);
                                  return s + ((x.qty || 0) * final);
                                }, 0) || 0)
                              )?.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>

                        {(details?.job_category_name != 'Service only' || subTotal > 0) &&
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Subtotal</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">
                              ${(
                                (subTotal || 0) +
                                // (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                                (cartService?.reduce((s, x) => {
                                  const sp = x.sellingPrice || x.unit_cost || 0;
                                  const markup = x.originalMarkup || x.product_markup || 0;
                                  const final = sp + (sp * markup / 100);
                                  return s + ((x.qty || 0) * final);
                                }, 0) || 0)
                                // +
                                // (invoice?.cust_product?.reduce((sum, val) => {
                                //     const labourService = val?.services?.find(
                                //       s => s.labour_cost_service_id === 10
                                //     );
                                //     return (
                                //       sum +
                                //       (labourService?.service_original_cost || 0) *
                                //         (labourService?.prQty || 0) *
                                //         (val?.locationQuantity || 1)
                                //     )
                                //   }, 0) || 0)
                              )?.toFixed(2)}
                            </Typography>
                          </TableCell>
                        </RowResultStyle>}

                        {invoice?.extra_discount > 0 && (
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Discount</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        )}

                        {/* {invoice?.tax_amount > 0 && ( */}
                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="overline">Tax</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>
                        {/* )} */}

                        <RowResultStyle>
                          <TableCell colSpan={3} />
                          <TableCell align="right">
                            <Typography variant="subtitle1"  sx={{ color: invoice?.total < 0 ? 'red' : 'inherit' }}>Total</Typography>
                          </TableCell>
                          <TableCell align="left" width={10}>
                            <Typography variant="subtitle1"  sx={{ color: invoice?.total < 0 ? 'red' : 'inherit' }}>${invoice?.total ? invoice?.total?.toFixed(2) : 0.00}</Typography>
                          </TableCell>
                        </RowResultStyle>

                        {invoice?.project_category == 13 ? '' : 
                          <>
                            {(userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
                            (details?.billing_type ? (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right" sx={{display:"flex", alignItems: "center",gap: 1}}>
                                <Typography fontSize={"small"} variant="caption"  sx={{ color:  'inherit' }}> (only viewable for admin)</Typography>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>Billing Type</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            ) : '') :""}
                          {(invoice?.total && details?.billing_type) ?
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>Minimum Payable Amount</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>${(invoice?.total && details?.billing_type)? parseFloat((invoice?.total *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            :""
                            }
                            {details?.totalPaidAmount > 0 && (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>Amount Paid</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>${details?.totalPaidAmount ? parseFloat(details?.totalPaidAmount)?.toFixed(2) : 0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            )}
                            {details?.totalPaidAmount > 0 && (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color: details?.dueAmount <= 0 ? 'inherit' : 'red' }}>Balance Due</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color: details?.dueAmount <= 0 ? 'inherit' : 'red' }}>${details?.dueAmount ? parseFloat(details?.dueAmount <= 0 ? 0.00 : details?.dueAmount)?.toFixed(2) : 0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            )}
                          </>
                        }
                        </TableBody>
                    </Table>
                  </TableContainer>
                  {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
                    <>
                      <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                      <Stack spacing={2}>
                        {invoice?.note_data?.map((val, index) => {
                          const { id, authorized_by, note, timestamp } = val;
                          return (
                            <Paper
                              key={id}
                              elevation={3}
                              sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={8}>
                                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                    {note}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                  {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                                  <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                    Added By: {authorized_by}
                                  </Typography>
                                  <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                    {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Paper>
                          );
                        })}
                      </Stack>
                    </>
                  ) : ''}
                  </>
                }
              </Box>
            </Stack>
          }
          {/* </Scrollbar> */}
        {/* </Grid> */}
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={{ xs: 2, sm: 3 }}
          mb={2}
        >
          {/* {empty(quotation) &&
            details?.job_category_name != 'Service only' &&
            details?.job_category_name != 'Time & Material' && ( */}
            {
              !proposalView &&
              <ListSubheader component="div">Designs / Documents</ListSubheader>
            }
            {/* )} */}
          {
          // empty(quotation) &&
            status !== 6 &&
            !user.isVendor && !proposalView &&
            !project &&
            details?.noServiceNoTask == 0 &&
            // details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material' &&
            !details?.installationStatus &&(
              <LoadingButton
                variant="outlined"
                size="small"
                sx={{ height: 40 }}
                onClick={() => {
                  let salesOrderPermission = !explodedPermissions?.some((permission) => ['Upload Files Sales Order'].includes(permission))
                  let estimatePermission = !explodedPermissions?.some((permission) => ['Upload Files Estimate'].includes(permission))
                  console.log("permission",estimatePermission,salesOrderPermission)
                  if(!isEstimate && salesOrderPermission &&  user?.added_by_client ==1){
                    return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                    
                  }else if(isEstimate && estimatePermission && user?.added_by_client ==1){
                    return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                  }else{
                    fileInputRef.current.click()
                  }
                  }
                 
                }
                loading={progress}
              >
                Upload Designs / Documents
              </LoadingButton>
            )}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
            accept="image/*,application/pdf"
          />
        </Stack>
        {designs && designs?.length && fromProposal &&!proposalView ? (
          //  style={{ width: project ? '150px' :'240px', height: '240px' }}
          <Box
            sx={{ border: '1px solid', borderColor: borderColor, padding: 2 }}
          >
            <Scrollbar sx={{ width: '100%', height: 450 }}>
              <ImageList
                gap={mdd ? 8 : xld ? 12 : 8}
                cols={mdd ? 3 : xld ? 3 : xs ? 1 : 3}
              >
                {/* <ImageListItem key="Subheader" cols={2}> */}
                {/* </ImageListItem> */}
                {designs?.map((item) => {
                  const { file_type, name, url } = item
                  const isImage =
                    file_type?.startsWith('image/') ||
                    file_type === 'img' ||
                    file_type === 'image'
                  const isPdf = file_type === 'pdf' || file_type === 'application/pdf' || file_type === "other"
                  return (
                    <ImageListItem key={item.name}>
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 8,
                          left: 10,
                        }}
                      >
                        {(item.approved === 1 && isImage) ? (
                          <Label
                            variant={'filled'}
                            color={'success'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Approved'}
                          </Label>
                        ) : item.product_id !== null ? (
                          ''
                        ) : // <Label
                        //   variant={'filled'}
                        //   color={'info'}
                        //   style={{ color: 'white', height: 20 }}
                        // >
                        //   {`Linked with ${item?.product_name}`}
                        // </Label>
                        item.reason ? (
                          <Label
                            variant={'filled'}
                            color={'error'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Rejected'}
                          </Label>
                        ) : null}
                      </Stack>
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 110,
                          left: 10,
                        }}
                      >
                        {item.approved === 1 ? (
                          // <Box
                          //   sx={{
                          //     position: 'absolute',
                          //     zIndex: 9,
                          //     bottom: 8,
                          //     left: 100,
                          //   }}
                          // >
                          //     <Typography
                          //       fontSize={'0.7rem'}
                          //       variant={'caption'}
                          //       sx={{ color: 'text.primary' }}
                          //     >
                          //       Approved By: {item.approved_by}
                          //     </Typography>

                          // </Box>

                          <Typography
                            sx={{ position: 'absolute', top: 40, zIndex: 100 }}
                          >
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color="success"
                            >
                              <Tooltip title={item.approved_by}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: 150, // Adjust as necessary
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Approved By: {item.approved_by}
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Label>
                          </Typography>
                        ) : item.reason ? (
                          // <Box
                          //   sx={{
                          //     position: 'absolute',
                          //     zIndex: 9,
                          //     bottom: 8,
                          //     left: 100,
                          //   }}
                          // >
                          //   <Typography
                          //     fontSize={'0.7rem'}
                          //     variant={'caption'}
                          //     sx={{ color: 'text.error' }}
                          //   >
                          //     Rejected Reason: {item.reason}
                          //   </Typography>
                          // </Box>
                          <Typography
                            sx={{ position: 'absolute', top: 40, zIndex: 100 }}
                          >
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color="error"
                            >
                              <Tooltip title={item.reason}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: 150, // Adjust as necessary
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Rejected Reason: {item.reason}
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Label>
                          </Typography>
                        ) : (
                          ''
                        )}
                      </Stack>

                      {isImage ? (
                        <img
                          srcSet={`${item.name}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                          src={`${item.name}?w=240&h=240&fit=crop&auto=format`}
                          alt={item.title}
                          loading="lazy"
                          // style={{ width: '240px', height: '240px' }}
                        />
                      ) : isPdf ? (
                        <Box display="flex" alignItems="center">
                          {/* PDF Icon Button */}
                          <Tooltip title="View">
                            <IconButton
                              onClick={() => {
                                setPdfLoading(true);
                                setSelectedPDF(name);
                                setOpenPDFModal(true);
                                setUseOfficeViewer(true); // Reset to try Office viewer first
                             }}
                              aria-label="open pdf"
                              sx={{
                                position: 'absolute',
                                top: 60,
                                right: '50%',
                                zIndex: 200,
                                color: theme.palette.error.main,
                                backgroundColor: theme.palette.text.primary,
                              }}
                            >
                              <PictureAsPdf style={{ fontSize: 40 }} />
                            </IconButton>
                          </Tooltip>

                          {/* Iframe */}
                          <iframe
                            src={name}
                            title={name}
                            style={{
                              width: project ? '150px' : '240px',
                              height: '240px',
                            }}
                            frameBorder="0"
                          />
                          <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
                            <Card className={classes.dialogContent}>
                              <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      onClick={() => {
                                        if (isClient || userType === 3) {
                                          // For clients/userType 3: Open PDF in new window without toolbar
                                          const newWindow = window.open('', '_blank');
                                          newWindow.document.write(`
                                            <html>
                                              <head>
                                                <title>PDF Viewer</title>
                                                <style>
                                                  body { margin: 0; padding: 0; overflow: hidden; }
                                                  iframe { width: 100vw; height: 100vh; border: none; }
                                                </style>
                                              </head>
                                              <body>
                                                <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                              </body>
                                            </html>
                                          `);
                                          newWindow.document.close();
                                        } else {
                                          // For other users: Open PDF normally
                                          window.open(selectedPDF, '_blank');
                                        }
                                      }}
                                      disabled={!selectedPDF}
                                      startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                      sx={{
                                        fontSize:'14px'
                                      }}
                                    >
                                      View PDF
                                    </Button>
                                </div>
                              {pdfLoading && (
                                <Skeleton variant="rectangular" width="100%" height={500} />
                              )}

                              {(isClient || userType === 3) && useOfficeViewer ? (
                                <iframe
                                  src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                  title="Selected PDF"
                                  width="100%"
                                  height="500px"
                                  frameBorder="0"
                                  style={{ display: pdfLoading ? 'none' : 'block' }}
                                  onLoad={() => setPdfLoading(false)}
                                  onError={() => {
                                    // If Google Docs viewer fails, fallback to direct iframe
                                    setUseOfficeViewer(false);
                                    setPdfLoading(false);
                                  }}
                                />
                              ) : (
                                <iframe
                                  src={selectedPDF}
                                  title="Selected PDF"
                                  width="100%"
                                  height="500px"
                                  frameBorder="0"
                                  style={{ display: pdfLoading ? 'none' : 'block' }}
                                  onLoad={() => setPdfLoading(false)}
                                />
                              )}
                            </Card>
                          </DialogAnimate>
                        </Box>
                      ) : (
                        // <iframe
                        //   src={name}
                        //   title={name}
                        //   style={{ width: '240px', height: '240px' }}
                        //   frameBorder="0"
                        // />
                        // <div
                        //   style={{ justifyContent: 'center', alignItems:'center', cursor: 'pointer', width: '240px', height: '240px' }}
                        // >
                        // <IconButton
                        //   onClick={() => window.open(name, '_blank')}
                        //   aria-label="open pdf"
                        //   sx={{ borderWidth:0.5,borderColor:'white', justifyContent: 'center', alignItems:'center', cursor: 'pointer', width: '240px', height: '240px' }}
                        // >
                        //   <PictureAsPdf style={{ fontSize: 40, color:theme.palette.error.main }} />
                        // </IconButton>
                        // </div>
                        <Typography
                          sx={{
                            color: theme.palette.error.main,
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: project ? '150px' : '240px',
                            height: '240px',
                          }}
                        >
                          Unsupported file type
                        </Typography>
                        // <Snackbar
                        //   open={true}
                        //   message="Unsupported file type"
                        //   style={{ width: '240px', height: '240px' }}
                        //   autoHideDuration={6000}
                        // />
                      )}
                      <ImageListItemBar
                        sx={{
                          width: mdd
                            ? '92%'
                            : sm
                            ? '20%'
                            : xld
                            ? '70%'
                            : xs
                            ? '35%'
                            : '64%',
                        }}
                        title={item.updated_by}
                        subtitle={moment
                          .unix(item.timestamp)
                          .format('MM/DD/YYYY')}
                        actionIcon={
                          <>
                            {
                              !user.isVendor && !project && ''
                              // <UserMoreMenu
                              //   common={{
                              //     name: (item?.approved !== 1 && item?.product_id !== null) && 'Approve',
                              //     function:
                              //     (item?.approved !== 1 && item?.product_id !== null) ? () => {
                              //       setItemId(item.id)
                              //       setModalClose(true)
                              //       handleUpdateDesign({
                              //         id: item.id,
                              //         // product_id: product.product_id,
                              //         approved: 1,
                              //         reason:null
                              //       })
                              //       // setOpenProductModel(true)
                              //     } : null ,
                              //     Iccon:
                              //     (item?.approved !== 1 && item?.product_id !== null) && (
                              //         <ThumbUpAltOutlined />
                              //       ),
                              //     modalClose: modalClose,
                              //   }}
                              //   linkImageWithTask={{
                              //     name: item?.product_id == null && 'Link with catalog',
                              //     function:
                              //     item?.product_id == null ? () => {

                              //             setItemId(item.id)
                              //             setModalClose(true)
                              //             setOpenProductModel(true)
                              //           } : null ,
                              //     Iccon: item?.product_id == null && (
                              //         <Link />
                              //       ),
                              //     modalClose: modalClose,
                              //   }}

                              //   common2={{
                              //     name: (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) && 'Reject',
                              //     function:
                              //     (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) ? () => {
                              //               setItemId(item.id)
                              //               setOpenReasonModal(true)
                              //           } : null ,
                              //     Iccon:
                              //     (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) && (
                              //         <ThumbDownOffAltOutlined />
                              //       )
                              //       ,
                              //     modalClose: modalClose,
                              //   }}
                              //   //   onDelete={() => handleUpdateDesign({ id: item.id, status: 0 })}
                              //   {...(item.approved === 1
                              //     ? {}
                              //     : {
                              //         onDelete: () =>
                              //           handleUpdateDesign({
                              //             id: item.id,
                              //             status: 0,
                              //           }),
                              //       })}
                              // />
                            }
                          </>
                        }
                      />
                      {openProductModel && itemId === item.id && (
                        <Card
                          sx={{
                            position: 'absolute',
                            zIndex: 10,
                            bottom: 5,
                            left: 5,
                            p: 2,
                          }}
                        >
                          <Stack
                            direction={'row'}
                            justifyContent={'space-between'}
                          >
                            <Typography marginBottom={2} variant="subtitle2">
                              Choose Products
                            </Typography>
                            <CancelOutlined
                              sx={{ cursor: 'pointer' }}
                              onClick={() => {
                                setModalClose(false)
                                setOpenProductModel(false)
                              }}
                            />
                          </Stack>
                          <Divider sx={{ marginBottom: 2 }} />
                          <Stack spacing={1}>
                            {products
                              ?.filter(
                                (prodItem) =>
                                  prodItem?.material === 0 &&
                                  prodItem?.rfp === 0,
                              )
                              ?.map((product) => (
                                <>
                                  <Typography
                                    sx={{ cursor: 'pointer' }}
                                    variant="caption"
                                    onClick={() =>
                                      handleUpdateDesign({
                                        id: item.id,
                                        product_id: product.product_id,
                                        product_name: product.product_name,
                                        // approved: 1,
                                        reason: null,
                                        num:1
                                      })
                                    }
                                  >
                                    {product.product_name}
                                  </Typography>
                                  <Divider />
                                </>
                              ))}
                          </Stack>
                        </Card>
                      )}

                      <Modal
                        open={openReasonModal && itemId === item.id}
                        handleClose={() => {
                          setOpenReasonModal(false)
                        }}
                        modalTitle={`Reason for Design Rejection`}
                      >
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Reason"
                              value={reasonText}
                              onChange={(e) => setReasonText(e.target.value)}
                            />
                            <Box
                              sx={{
                                mt: 3,
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 1,
                              }}
                            >
                              <LoadingButton
                                type="submit"
                                variant="contained"
                                onClick={() =>
                                  handleUpdateDesign({
                                    id: itemId,
                                    product_id: null,
                                    product_name: null,
                                    reason: reasonText,
                                    approved: 0,
                                    num:2
                                  })
                                }
                                // loading={isSubmitting}
                              >
                                {' Save '}
                              </LoadingButton>
                              <Button
                                variant="outlined"
                                type="submit"
                                onClick={() => {
                                  setOpenReasonModal(false)
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Modal>
                    </ImageListItem>
                  )
                })}
              </ImageList>
            </Scrollbar>
          </Box>
        ) : (
          ''
        )}

        {designs && designs?.length && !fromProposal ? (
          <Box
            sx={{
              padding: 3,
              border: '1px solid', // ✅ Green border
              borderColor:borderColor,
              borderRadius: 3,
              // backgroundColor: 'rgba(0, 255, 0, 0.05)', // Light green tint for better visibility
            }}
          >
            <Scrollbar sx={{ width: '100%', height: 600 }}>
              {' '}
              {/* ✅ Increased height */}
              <ImageList
                sx={{
                  padding: '10px',
                  display: 'grid',
                  // gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: 6, // ✅ Added more spacing
                }}
                cols={mdd ? 3 : xld ? 3 : xs ? 1 : 3}
              >
                                   {/* Sales order attachments---------- */}
                {designs?.map((item,index) => {
                  const { file_type, name, location_ids } = item
                  console.log('itemitemitem',item)
                  let filteredProducts = productsWithLocation?.filter((prodItem) => {
                    // Convert linkedLocationIds to an array of numbers
                    const linkedProductsArray = item?.linkedLocationIds
                        ? item?.linkedLocationIds.split(',').map(id => parseInt(id.trim(), 10)) // Convert to array of numbers
                        : [];
                
                    // Check if prodItem.id is NOT in the linkedProductsArray
                    return (
                        prodItem?.material === 0 &&
                        prodItem?.rfp === 0 &&
                        !linkedProductsArray.includes(prodItem.request_location_id) // Exclude linked productsWithLocation
                    );
                });
  
                
                  const isImage = file_type?.startsWith('image/') || file_type === 'img' || file_type === 'image'
                  const isPdf = file_type === 'pdf' || file_type === 'application/pdf' || file_type === "other"
                  return (
                    <ImageListItem
                      key={item.name}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 250, // ✅ Increased width
                        height: 250, // ✅ Increased height
                        backgroundColor: 'rgba(0, 0, 0, 0.05)',
                        borderRadius: 2, // ✅ Softer border radius
                        padding: 2,
                        position: 'relative',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // ✅ Added shadow for better visibility
                        border: '1px solid',
                        borderColor: (item.approved === 1 && details?.job_category_name !== 'Service only' && isImage) ? theme.palette.success.main : item.reason ? theme.palette.error.main : theme.palette.info.main,
                      }}
                    >
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 8,
                          left: 10,
                        }}
                      >
                        {(item.approved === 1 && isImage && details?.job_category_name !== 'Service only') ? (
                          (location_ids !== null ||  location_ids !== '') ? (
                            // <Tooltip title={`Linked with ${item?.product_name}`}>
                            <Tooltip
                              title={`Linked with : ${[...new Map(item?.productNames.map(p => [p.product_id, p])).values()]
                                .map((p, index) => `(${index + 1}). ${p?.product_name}`) // Add index before each unique product name
                                .join(', ')}`}
                              // title={`Linked with: ${item?.productNames
                              // .map((p, index) => `(${index + 1}). ${p?.product_name}`) // Add index before each product name
                              // .join(', ')}`} // Join all names into a single string
                              arrow
                            >
                              <span>
                                <Label
                                  variant={'filled'}
                                  color={'success'}
                                  style={{ color: 'white', height: 22, width: 200 }}
                                >
                                  {/* Approved */}
                                  Linked with Catalog & Approved
                                </Label>
                              </span>
                            </Tooltip>
                          ) : (
                          <Label
                            variant={'filled'}
                            color={'success'}
                            style={{ color: 'white', height: 22, width: 110 }}
                          >
                            Approved
                          </Label>
                        )) :
                        (item?.location_ids && item?.location_ids.length > 0) || (item?.productNames && item?.productNames.length > 0)?(
                        // ( location_ids != null ||  location_ids != '') ? (

                          // <Tooltip title={`Linked with : ${item?.productNames.map(p =>p?.product_name)} `} arrow>
                          <Tooltip
                            // title={`Linked with: ${item?.productNames
                            // .map((p, index) => `(${index + 1}). ${p?.product_name}`) // Add index before each product name
                            // .join(', ')}`} // Join all names into a single string

                            title={`Linked with: ${[...new Map(item?.productNames.map(p => [p.product_id, p])).values()]
                              .map((p, index) => `(${index + 1}). ${p?.product_name}`)
                              .join(', ')}`}
                            arrow
                          >

                            <span>
                              <Label
                                variant={'filled'}
                                color={'info'}
                                style={{ color: 'white', height: 20 }}
                              >
                                {/* {`Linked with: ${
                                   item?.productNames
                                     ?.map(p => p?.product_name) // Extract product names
                                     ?.join(', ') // Join them as a single string
                                     ?.length > 15 // Check total length
                                     ? item?.productNames.map(p => p?.product_name).join(', ').substring(0, 12) + '...' // Shorten if necessary
                                     : item?.productNames.map(p => p?.product_name).join(', ') // Otherwise, show full names
                                 }`} */}

                                  {`Linked with: ${
                                    (() => {
                                      const uniqueNames = [...new Map(item?.productNames.map(p => [p.product_id, p.product_name])).values()];
                                      const fullString = uniqueNames.join(', ');

                                      return fullString.length > 15 
                                        ? fullString.substring(0, 12) + '...' 
                                        : fullString;
                                    })()
                                  }`}

                                  {/* {`Linked: ${
                                    item?.product_name.length > 15 // Shorten dynamically
                                      ? item?.product_name.substring(0, 12) + '...' // Show first 12 chars + "..."
                                      : item?.product_name
                                  }`} */}
                              </Label>
                            </span>
                          </Tooltip>
                        ) : item.reason ? (
                          <Tooltip title={`Reason : ${item.reason}`}>
                            <span>
                              <Label
                                variant={'filled'}
                                color={'error'}
                                style={{ color: 'white', height: 22, width: 110 }}
                              >
                                Rejected
                              </Label>
                            </span>
                          </Tooltip>
                        ) : null}
                      </Stack>

                      {/* Image / PDF Preview */}
                      {isImage ? (
                        <a
                          // href={name}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault();
                            handleImageClick(imageDesigns.findIndex((img) => img.name === name))
                          }}
                        >
                          <Tooltip title="View Design">
                            <img
                              src={name}
                              alt={name}
                              loading="lazy"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                borderRadius: 8,
                              }}
                            />
                          </Tooltip>
                        </a>
                      ) : isPdf ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            // justifyContent: 'center',
                            // width: '100%',
                            // height: '100%',
                          }}
                        >
                          <Tooltip title="View PDF">
                            <IconButton
                              onClick={() => {
                                setPdfSecondLoading(true);
                                setSelectedSecondPDF(name);
                                setOpenPDFSecondModal(true);
                                setUseOfficeViewerSecond(true); // Reset to try Office viewer first
                              }}
                              aria-label="open pdf"
                                sx={{ position:'absolute', 
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                               zIndex: 200,color:theme.palette.error.main, backgroundColor:theme.palette.text.primary }} 
                            >
                              <PictureAsPdf
                                style={{ fontSize: 50, color: 'red' }}
                              />{' '}
                              {/* ✅ Increased size */}
                            </IconButton>
                          </Tooltip>

                          {/* Iframe */}
                          <iframe
                            src={name}
                            title={name}
                            style={{ width: project ? '150px' :'240px', height: '240px' }}
                            frameBorder="0"
                          />

                          <DialogAnimate open={openPDFSecondModal} onClose={() => setOpenPDFSecondModal(false)}>
                            <Card className={classes.dialogContent}>
                              <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      onClick={() => {
                                        if (isClient || userType === 3) {
                                          // For clients/userType 3: Open PDF in new window without toolbar
                                          const newWindow = window.open('', '_blank');
                                          newWindow.document.write(`
                                            <html>
                                              <head>
                                                <title>PDF Viewer</title>
                                                <style>
                                                  body { margin: 0; padding: 0; overflow: hidden; }
                                                  iframe { width: 100vw; height: 100vh; border: none; }
                                                </style>
                                              </head>
                                              <body>
                                                <iframe src="${selectedSecondPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                              </body>
                                            </html>
                                          `);
                                          newWindow.document.close();
                                        } else {
                                          // For other users: Open PDF normally
                                          window.open(selectedSecondPDF, '_blank');
                                        }
                                      }}
                                      disabled={!selectedSecondPDF}
                                      startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                      sx={{
                                        fontSize:'14px'
                                      }}
                                    >
                                      View PDF
                                    </Button>
                                </div>
                              {pdfSecondLoading && (
                                <Skeleton variant="rectangular" width="100%" height={500} />
                              )}

                              {(isClient || userType === 3) && useOfficeViewerSecond ? (
                                <iframe
                                  src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedSecondPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                  title="Selected PDF"
                                  width="100%"
                                  height="500px"
                                  frameBorder="0"
                                  style={{ display: pdfSecondLoading ? 'none' : 'block' }}
                                  onLoad={() => setPdfSecondLoading(false)}
                                  onError={() => {
                                    // If Google Docs viewer fails, fallback to direct iframe
                                    setUseOfficeViewerSecond(false);
                                    setPdfSecondLoading(false);
                                  }}
                                />
                              ) : (
                                <iframe
                                  src={selectedSecondPDF}
                                  title="Selected PDF"
                                  width="100%"
                                  height="500px"
                                  frameBorder="0"
                                  style={{ display: pdfSecondLoading ? 'none' : 'block' }}
                                  onLoad={() => setPdfSecondLoading(false)}
                                />
                              )}
                            </Card>
                          </DialogAnimate>
                        </Box>
                      ) : (
                        <Typography
                          sx={{
                            color: 'error.main',
                            fontSize: '14px',
                            textAlign: 'center',
                          }}
                        >
                          Unsupported file type
                        </Typography>
                      )}

                      {/* File Info Bar */}
                      <ImageListItemBar
                        // title={item.updated_by}
                        subtitle={moment
                          .unix(item.timestamp)
                          .format('MM/DD/YYYY')}
                        sx={{
                          backgroundColor: 'rgba(0, 0, 0, 0.6)',
                          fontSize: '14px', // ✅ Slightly increased font size
                          borderRadius: 2,
                          overflow: 'hidden',
                        }}
                        actionIcon={
                          <>
                            {!(user.isVendor && project) && (((item?.approved !== 1 && isImage) || !isImage)|| details?.job_category_name == 'Service only' ) && !details?.installationStatus && (
                              <UserMoreMenu
                                common={{
                                  name:
                                    item?.approved !== 1 && details?.job_category_name !== 'Service only' &&
                                    (item?.location_ids !== null &&  item?.location_ids !== '') && !isEstimate &&
                                    // item?.product_id !== null &&
                                    'Approve',
                                  function:
                                    item?.approved !== 1 &&
                                    (item?.location_ids !== null &&  item?.location_ids !== '')
                                    // item?.product_id !== null
                                      ? () => {
                                          setItemId(item.id)
                                          setModalClose(true)
                                          handleUpdateDesign({
                                            id: item.id,
                                            // product_id: product.product_id,
                                            approved: 1,
                                            reason: null,
                                            num:3
                                          })
                                          // setOpenProductModel(true)
                                        }
                                      : null,
                                  Iccon: item?.approved !== 1 &&
                                    // item?.product_id !== null && (
                                      (item?.location_ids !== null &&  item?.location_ids !== '') &&(
                                      <ThumbUpAltOutlined />
                                    ),
                                  modalClose: modalClose,
                                }}
                                linkImageWithTask={
                                  productsWithLocation?.length > 0 && item?.product_id === null ? {
                                    name:
                                      item?.product_id == null && item.reason==null &&
                                      details?.job_category_name !== 'Service only' &&
                                      // !isEstimate &&
                                      item?.file_type?.includes('image')
                                      ? 'Link with catalog'
                                      : '',
                                    function:
                                      item?.product_id == null && item?.file_type?.includes('image')
                                        ? () => {
                                          let estimatePermission = explodedPermissions?.some((permission) => ['Link With Catalog Estimate Designs'].includes(permission))
                                          let salesOrderPermission = explodedPermissions?.some((permission) => ['Link With Catalog Sales Order Designs'].includes(permission))
                                          if(isEstimate && !estimatePermission &&  userType !==1){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }else if(isRequest && !salesOrderPermission &&  userType !==1){
                                            return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                          }
                                          
                                            setItemId(item.id)
                                            setModalClose(true)
                                            setOpenProductModel(true)
                                            initializeSelectedProducts(item);
                                          }
                                        : null,
                                    Iccon: item?.product_id == null && <Link />,
                                    modalClose: modalClose,
                                  } : null
                                }
                                common2={{
                                  name:
                                    (item?.approved === 1 ||
                                      (item?.approved === 0 &&
                                        item?.reason === null)) &&
                                        details?.job_category_name !== 'Service only' &&
                                        // !isEstimate &&
                                        item?.file_type?.includes('image')
                                      ? 'Reject'
                                      : '',
                                  function:
                                    item?.approved === 1 ||
                                    (item?.approved === 0 &&
                                      item?.reason === null) &&
                                      item?.file_type?.includes('image')
                                      ? () => {
                                        let estimatePermission = explodedPermissions?.some((permission) => ['Reject Estimate Designs'].includes(permission))
                                        let salesOrderPermission = explodedPermissions?.some((permission) => ['Reject Sales Order Designs'].includes(permission))
                                     
                                        if(isEstimate && !estimatePermission && userType !==1){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }else if(isRequest && !salesOrderPermission &&  userType !==1){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }
                                          setItemId(item.id)
                                          setOpenReasonModal(true)
                                        }
                                      : null,
                                  Iccon: (item?.approved === 1 ||
                                    (item?.approved === 0 &&
                                      item?.reason === null)) && (
                                    <ThumbDownOffAltOutlined />
                                  ),
                                  modalClose: modalClose,
                                }}
                                //   onDelete={() => handleUpdateDesign({ id: item.id, status: 0 })}
                                {...((item.approved === 1 && details?.job_category_name !== 'Service only' && isImage)
                                  ? {}
                                  : {
                                      onDelete: () =>{
                                        let estimatePermission = explodedPermissions?.some((permission) => ['Delete Estimate Designs / Documents'].includes(permission))
                                        let salesOrderPermission = explodedPermissions?.some((permission) => ['Delete Sales Order Designs / Documents'].includes(permission))
                                        if(isEstimate && !estimatePermission &&  userType !==1){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }else if(isRequest && !salesOrderPermission &&  userType !==1){
                                          return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });

                                        }
                                        handleUpdateDesign({
                                          id: item.id,
                                          status: 0,
                                          num:4
                                        })},
                                    })}
                              />
                            )}
                          </>
                        }
                      />
                      {openProductModel && itemId === item.id && (
                        <Card
                          sx={{
                            position: 'absolute',
                            zIndex: 10,
                            bottom: 5,
                            left: 5,
                            p: 2,
                            top: 20,
                            maxHeight: '600px',  
                            overflowY: 'auto',
                            width:"250px"
                          }}
                          // sx={{
                          //   position: 'absolute',
                          //   zIndex: 10,
                          //   bottom: 'auto',
                          //   left: 'auto',
                          //   top: 50,       
                          //   boxShadow: 3,
                          //   p: 2,
                          //   borderRadius: 2, 
                          // }}
                        >
                          <Stack
                            direction={'row'}
                            justifyContent={'space-between'}
                            
                          >
                            <Typography  variant="subtitle2">
                              Choose Product
                            </Typography>
                            <CancelOutlined
                              sx={{ cursor: 'pointer' }}
                              onClick={() => {
                                setModalClose(false)
                                setOpenProductModel(false)
                                setSelectedProducts([])
                              }}
                            />
                          </Stack>

                          {filteredProducts?.length > 0 ? (
      //                     <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
      // <Checkbox
      //   checked={selectedProducts.length === products.length} // If all selected, check "Select All"
      //   indeterminate={selectedProducts.length > 0 && selectedProducts.length < products.length} // Partial selection indicator
      //   onChange={(e) => {
      //     if (e.target.checked) {
      //       // Select all
      //       setSelectedProducts(
      //         products.map((product) => ({
      //           id: item.id,
      //           // product_id: product.product_id,
      //           product_id: product.id,
      //           product_name: product.product_name,
      //           reason: null,
      //           num: 5,
      //         }))
      //       );
      //     } else {
      //       // Deselect all
      //       setSelectedProducts([]);
      //     }
      //   }}
      // />
      // <Typography variant="caption" sx={{ cursor: 'pointer' }} onClick={() => {
      //   // Toggle Select All when clicking text
      //   const allSelected = selectedProducts.length === products.length;
      //   setSelectedProducts(
      //     allSelected
      //       ? []
      //       : products.map((product) => ({
      //           id: item.id,
      //           product_id: product.product_id,
      //           product_name: product.product_name,
      //           reason: null,
      //           num: 5,
      //         }))
      //   );
      // }}>
      //   Select All
      // </Typography>
      //                      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
  <Checkbox
    checked={selectedProducts.length === filteredProducts.length} // ✅ Match against filteredProducts, not all products
    indeterminate={selectedProducts.length > 0 && selectedProducts.length < filteredProducts.length} // ✅ Partial selection
    onChange={(e) => {
      if (e.target.checked) {
        // ✅ Select only filteredProducts
        setSelectedProducts(
          filteredProducts.map((product) => ({
            id: item.id,
            product_id: product.request_location_id, // ✅ Use filtered product ID
            product_name: product.product_name,
            reason: null,
            num: 5,
          }))
        );
      } else {
        // ✅ Deselect all
        setSelectedProducts([]);
      }
    }}
  />
  <Typography
    variant="caption"
    sx={{ cursor: 'pointer' }}
    onClick={() => {
      const allSelected = selectedProducts.length === filteredProducts.length;
      setSelectedProducts(
        allSelected
          ? []
          : filteredProducts.map((product) => ({
              id: item.id,
              product_id: product.request_location_id, // ✅ Use filtered product ID
              product_name: product.product_name,
              reason: null,
              num: 5,
            }))
      );
    }}
  >
    Select All
  </Typography>
</Box>

                          ) : null}
    <Divider sx={{ marginBottom: 2 }} />

    <Stack spacing={1}>
    {filteredProducts.length > 0 ? (
      filteredProducts.map((product) => {
       
        return(
        
        <Box key={product.request_location_id} sx={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            checked={selectedProducts.some((p) => p.product_id === product.request_location_id)}
            onChange={(e) => handleCheckboxChange(product, e.target.checked, item)}
          />
          <Typography sx={{ cursor: 'pointer' }} variant="caption">
            {product.product_name}
          </Typography>
          <Divider />
        </Box>
      )})
    ) : (
      // ✅ Display "No Products Left" message when no products are available
      <Typography variant="body2" sx={{ textAlign: "center", color: "gray", padding: 2 }}>
        No products left
      </Typography>
    )}
  </Stack>

  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
    <Button
      onClick={() => {
        setModalClose(false);
        setOpenProductModel(false);
        setSelectedProducts([]);
      }}
      sx={{ color: "red" }}
    >
      Close
    </Button>
    {filteredProducts.length > 0 && <Button onClick={()=>handleSubmit(item.id)}>Submit</Button>}
  </Box>
                          

                        </Card>
                      )}

                      <Modal
                        open={openReasonModal && itemId === item.id}
                        handleClose={() => {
                          setOpenReasonModal(false)
                        }}
                        modalTitle={`Reason for Design Rejection`}
                      >
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Reason"
                              value={reasonText}
                              onChange={(e) => setReasonText(e.target.value)}
                            />
                            <Box
                              sx={{
                                mt: 3,
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 1,
                              }}
                            >
                              <LoadingButton
                                type="submit"
                                variant="contained"
                                onClick={() =>
                                  handleUpdateDesign({
                                    id: itemId,
                                    product_id: null,
                                    product_name: null,
                                    reason: reasonText,
                                    approved: 0,
                                    num:6
                                  })
                                }
                                // loading={isSubmitting}
                              >
                                {' Save '}
                              </LoadingButton>
                              <Button
                                variant="outlined"
                                type="submit"
                                onClick={() => {
                                  setOpenReasonModal(false)
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Modal>
                    </ImageListItem>
                  )
                })}


              </ImageList>
            </Scrollbar>
          </Box>
        ) : (
          ''
        )}
        <Modal width={1000}
              open={openImageModal}
              handleClose={() => {
                setOpenImageModal(false);
              }}
              modalTitle={'Designs'}
              >
              <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                gap:'1rem',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
            <IconButton
              onClick={handlePrevious}
              disabled={currentImageIndex === 0}
              sx={{
                opacity: currentImageIndex === 0 ? 0.3 : 1,
                pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowLeftOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>

            <Box
            component={'div'} 
              style={{
                width: '500px',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
                overflow:'hidden'
              }}
            >
              <img
                src={imageDesigns[currentImageIndex]?.name}
                alt={`Image ${currentImageIndex + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
              />
            </Box>
            <IconButton
              onClick={handleNext}
              disabled={currentImageIndex === imageDesigns.length - 1}
              sx={{
                opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
                pointerEvents: currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowRightOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>
          </div>
        </Modal>
        
        {/* previos code */}
        {/* {designs?.length && !fromProposal ? (
          <Box>
            <Scrollbar sx={{ width: '100%', height: 550 }}>
              <ImageList
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingLeft: '2px',
                  paddingRight: '2px',
                }}
                gap={mdd ? 8 : xld ? 12 : 8}
                cols={mdd ? 3 : xld ? 3 : xs ? 1 : 3}
              >
                {designs?.map((item) => {
                  const { file_type, name, url } = item
                  const isImage =
                    file_type?.startsWith('image/') || file_type === 'img'
                  const isPdf = file_type === 'pdf' || 'application/pdf'
                  return (
                    <ImageListItem key={item.name}>
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 8,
                          left: 10,
                        }}
                      >
                        {item.approved === 1 ? (
                          <Label
                            variant={'filled'}
                            color={'success'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Approved'}
                          </Label>
                        ) : item.product_id !== null ? (
                          ''
                        ) : item.reason ? (
                          <Label
                            variant={'filled'}
                            color={'error'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Rejected'}
                          </Label>
                        ) : null}
                      </Stack>
                      <Stack
                        sx={{
                          position: 'absolute',
                          zIndex: 9,
                          top: 110,
                          left: 10,
                        }}
                      >
                        {item.approved === 1 ? (
                          <Typography
                            sx={{ position: 'absolute', top: 40, zIndex: 100 }}
                          >
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color="success"
                            >
                              <Tooltip title={item.approved_by}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: 150, // Adjust as necessary
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Approved By: {item.approved_by}
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Label>
                          </Typography>
                        ) : item.reason ? (
                          <Typography
                            sx={{ position: 'absolute', top: 40, zIndex: 100 }}
                          >
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color="error"
                            >
                              <Tooltip title={item.reason}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: 150,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Rejected Reason: {item.reason}
                                  </span>
                                </Typography>
                              </Tooltip>
                            </Label>
                          </Typography>
                        ) : (
                          ''
                        )}
                      </Stack>

                      {isImage ? (
                        <img
                          srcSet={`${item.name}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                          src={`${item.name}?w=240&h=240&fit=crop&auto=format`}
                          alt={item.title}
                          loading="lazy"
                        />
                      ) : isPdf ? (
                        <Box display="flex" alignItems="center">
                          <iframe
                            src={name}
                            type="application/pdf"
                            width="100%"
                            height="400px"
                            style={{
                              borderRadius: '10px',
                              border: '1px #2f444b solid',
                            }}
                          />
                        </Box>
                      ) : (
                        <Typography
                          sx={{
                            color: theme.palette.error.main,
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: project ? '150px' : '240px',
                            height: '240px',
                          }}
                        >
                          Unsupported file type
                        </Typography>
                      )}

                      {openProductModel && itemId === item.id && (
                        <Card
                          sx={{
                            position: 'absolute',
                            zIndex: 10,
                            bottom: 5,
                            left: 5,
                            p: 2,
                          }}
                        >
                          <Stack
                            direction={'row'}
                            justifyContent={'space-between'}
                          >
                            <Typography marginBottom={2} variant="subtitle2">
                              Choose Product
                            </Typography>
                            <CancelOutlined
                              sx={{ cursor: 'pointer' }}
                              onClick={() => {
                                setModalClose(false)
                                setOpenProductModel(false)
                              }}
                            />
                          </Stack>
                          <Divider sx={{ marginBottom: 2 }} />
                          <Stack spacing={1}>
                            {products
                              ?.filter(
                                (prodItem) =>
                                  prodItem?.material === 0 &&
                                  prodItem?.rfp === 0,
                              )
                              ?.map((product) => (
                                <>
                                  <Typography
                                    sx={{ cursor: 'pointer' }}
                                    variant="caption"
                                    onClick={() =>
                                      handleUpdateDesign({
                                        id: item.id,
                                        product_id: product.product_id,
                                        product_name: product.product_name,
                                        // approved: 1,
                                        reason: null,
                                      })
                                    }
                                  >
                                    {product.product_name}
                                  </Typography>
                                  <Divider />
                                </>
                              ))}
                          </Stack>
                        </Card>
                      )}

                      <Modal
                        open={openReasonModal && itemId === item.id}
                        handleClose={() => {
                          setOpenReasonModal(false)
                        }}
                        modalTitle={`Reason for Design Rejection`}
                      >
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Reason"
                              value={reasonText}
                              onChange={(e) => setReasonText(e.target.value)}
                            />
                            <Box
                              sx={{
                                mt: 3,
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 1,
                              }}
                            >
                              <LoadingButton
                                type="submit"
                                variant="contained"
                                onClick={() =>
                                  handleUpdateDesign({
                                    id: itemId,
                                    reason: reasonText,
                                    approved: 0,
                                  })
                                }
                                // loading={isSubmitting}
                              >
                                {' Save '}
                              </LoadingButton>
                              <Button
                                variant="outlined"
                                type="submit"
                                onClick={() => {
                                  setOpenReasonModal(false)
                                }}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Modal>
                    </ImageListItem>
                  )
                })}
              </ImageList>
            </Scrollbar>
          </Box>
        ) : (
          ''
        )} */}
      </Stack>

      {/* {(user.isVendor === null || user.isVendor === 0) &&(
      <AccountNotifications
                  isRequest={true}
                  requestId={requestId}
                 signAgreements={signAgreements}
                 customTemplate={customTemplate}
                 questionnaireTemplate={questionnaireTemplate}
                 allDataEmpty={allDataEmpty}
                 portfolio={portfolio}
                 updatingFunction={fetchRequestDetails}/>
                 )} */}

      {/* 🚀 PROGRESS TRACKING: Socket progress modal */}
      <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        onSocketReady={setSocketReady}
        heading={progressHeading}
      />
    </Card>
  )
}
